import { render, staticRenderFns } from "./RestaurantSettingsDialog.vue?vue&type=template&id=4dfa6de1"
import script from "./RestaurantSettingsDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports